module.exports = __webpack_public_path__ + "static/media/shampoo.d6012ad3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/amenities/shampoo.svg
// module id = 581
// module chunks = 0